export default __webpack_public_path__ + "static/media/Snd_TryN.eb6acc99.mp3";